<script>
  export let lang = undefined;

  const i18n = {
    time: {
      cs: 'Čas',
      en: 'Time',
    },
    group: {
      cs: 'Sk.',
      en: 'Gr.',
    },
    visitor: {
      cs: 'Hosté',
      en: 'Visitor',
    },
    home: {
      cs: 'Domácí',
      en: 'Home',
    },
    field: {
      cs: 'Hřiště',
      en: 'Field',
    },
    score: {
      cs: 'Skóre',
      en: 'Score',
    },
  };
</script>

<div class='game-legend'>
  <div class='game-legend-prepend'>
    <div class='game-legend-prepend-number'> ## </div>

    <div class='game-legend-prepend-time'> {i18n.time[lang]} </div>

    <div class='game-legend-prepend-group'> {i18n.group[lang]} </div>
  </div>

  <div class='game-legend-teams'>
    <div class='game-legend-teams-visitor'> {i18n.visitor[lang]} </div>

    <div class='game-legend-teams-home'> {i18n.home[lang]} </div>
  </div>

  <div class='game-legend-append'>
    <div class='game-legend-append-field'> {i18n.field[lang]} </div>

    <div class='game-legend-append-score'> {i18n.score[lang]} </div>
  </div>
</div>

<div class='game-legend-small'>
  <div class='game-legend-small-info'>
    <div class='game-legend-small-info-prepend'>
      <div class='game-legend-small-info-prepend-number'> ## </div>

      <div class='game-legend-small-info-prepend-time'> {i18n.time[lang]} </div>

      <div class='game-legend-small-info-prepend-group'> {i18n.group[lang]} </div>
    </div>

    <div class='game-legend-small-info-append'>
      <div class='game-legend-small-info-append-field'> {i18n.field[lang]} </div>
    </div>
  </div>

  <div class='game-legend-small-teams'>
    <div class='game-legend-small-teams-visitor'> {i18n.visitor[lang]} </div>

    <div class='game-legend-small-teams-home'> {i18n.home[lang]} </div>
  </div>
</div>

<style>
  .game-legend {
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 15px;

    padding: 0px 20px;

    text-transform: uppercase;

    font-size: 10px;
    font-weight: 550;

    letter-spacing: 1px;

    color: var(--grey-5);
  }

  .game-legend-prepend {
    display: flex;
    gap: 10px;

    width: 200px;
  }

  .game-legend-prepend-number {
    display: flex;
    justify-content: center;

    width: calc(20px / 3 * 4);
  }

  .game-legend-prepend-time {
    display: flex;
    justify-content: center;

    width: 45px;
  }

  .game-legend-prepend-group {
    display: flex;
    justify-content: center;

    width: 30px;
  }

  .game-legend-teams {
    display: flex;
    gap: 20px;
  }

  .game-legend-teams-visitor, .game-legend-teams-home {
    display: flex;
    justify-content: center;

    width: 150px;
  }

  .game-legend-append {
    display: flex;
    gap: 10px;

    width: 200px;
  }

  .game-legend-append-field {
    display: flex;
    justify-content: center;

    width: 100%;
  }

  .game-legend-append-score {
    display: flex;
    justify-content: center;
    flex-shrink: 0;

    width: calc(20px / 3 * 8 + 10px);
  }

  .game-legend-small {
    display: none;
    flex-direction: column;

    padding: 0px 20px;

    text-transform: uppercase;

    font-size: 10px;
    font-weight: 550;

    letter-spacing: 1px;

    color: var(--grey-5);
  }

  .game-legend-small-info {
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 15px;
  }

  .game-legend-small-info-prepend {
    display: flex;
    gap: 10px;
  }

  .game-legend-small-info-prepend-number {
    display: flex;
    justify-content: center;

    width: calc(20px / 3 * 4);
  }

  .game-legend-small-info-prepend-time {
    display: flex;
    justify-content: center;

    width: 45px;
  }

  .game-legend-small-info-prepend-group {
    display: flex;
    justify-content: center;

    width: 30px;
  }

  .game-legend-small-info-append {
    display: flex;
  }

  .game-legend-small-info-append-field {
    display: flex;
    justify-content: center;

    width: 125px;
  }

  .game-legend-small-teams {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

    height: 15px;
  }

  .game-legend-small-teams-visitor, .game-legend-small-teams-home {
    display: flex;
    justify-content: center;

    width: 150px;
  }

  :global(body.dark) .game-legend {
    color: var(--grey-6);
  }

  @media only screen and (max-width: 1300px) and (min-width: 1050px) {
    :global(.schedule-narrow) .game-legend-prepend {
      width: 125px;
    }

    :global(.schedule-narrow) .game-legend-teams-home, :global(.schedule-narrow) .game-legend-teams-visitor {
      width: 75px;
    }

    :global(.schedule-narrow) .game-legend-append {
      width: 125px;
    }
  }

  @media only screen and (max-width: 850px) {
    .game-legend-prepend {
      width: 125px;
    }

    .game-legend-teams-home, .game-legend-teams-visitor {
      width: 75px;
    }

    .game-legend-append {
      width: 125px;
    }
  }

  @media only screen and (max-width: 600px) {
    .game-legend {
      display: none;
    }

    .game-legend-small {
      display: flex;
    }
  }

  @media only screen and (max-width: 450px) {
    .game-legend-small-info-append-field {
      width: 40px;
    }

    .game-legend-small-teams-visitor, .game-legend-small-teams-home {
      width: 75px;
    }
  }
</style>
